<template>
  <v-container
    fill-height
    fluid
    class="background"
    style="margin: 0px; padding: 0px; width: 100%"
  >
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        md6>
        <v-card
          max-height="800px"
          class="elevation-12">
          <v-toolbar color="heron_toolbar">
            <v-avatar
              color="tranparent"
              size="70">
              <img src="../assets/img/energy-control.png" >
            </v-avatar>
            <v-toolbar-title
              class="toolbar_text--text"
            >Energy Control</v-toolbar-title
            >
            <v-spacer />
            <img
              src="../assets/img/heron_icon.svg"
              width="70" >
          </v-toolbar>
          <v-card-title class="title font-weight-bold">
            <v-spacer />
            Όροι, Προϋποθέσεις και Ενημέρωση Ευρωπαϊκών Προγραμμάτων (2/3)
            <v-spacer />
            <a
              href="../../static/EU_projects.pdf"
              download>
              <v-icon
                color="blue darken-2"
                large>mdi-download</v-icon>
            </a>
          </v-card-title>
          <v-card-text @scroll="handleScroll">
            <pdf
              v-for="i in 4"
              :style="{ width: zoom_string }"
              :key="i"
              :page="i"
              src="../../static/EU_projects.pdf"
            />
            <v-flex xs12>
              <v-checkbox
                v-model="termsCheckbox"
                :disabled="termsCheckboxDisabled"
                class="highlight--text"
                color="#323d77"
                label="Αποδέχομαι τους Όρους και Προϋποθέσεις συμμετοχής στα επιστημονικά ερευνητικά προγράμματα της Εταιρείας «ΗΡΩΝ ΕΝΕΡΓΕΙΑΚΗ Α.Ε.»"
                @change="check()"
              />
              <v-checkbox
                v-model="dataProcessingCheckbox"
                :disabled="dataProcessingCheckboxDisabled"
                class="highlight--text"
                color="#323d77"
                label="Αποδέχομαι την επεξεργασία των προσωπικών μου δεδομένων στα πλαίσια συμμετοχής στα επιστημονικά ερευνητικά προγράμματα της Εταιρείας «ΗΡΩΝ ΕΝΕΡΓΕΙΑΚΗ Α.Ε.»"
                @change="check()"
              />
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-container
              grid-list-md
              text-xs-center>
              <v-layout
                row
                wrap>
                <v-flex xs12>
                  <v-icon
                    large
                    @click="zoomIn()"
                  >mdi-magnify-plus-outline
                  </v-icon>
                  <v-icon
                    large
                    @click="zoomOut()"
                  >mdi-magnify-minus-outline</v-icon
                  >
                </v-flex>

                <v-flex>
                  <v-btn
                    block
                    class="mr-2"
                    color="heron_info"
                    @click="back">
                    πισω
                  </v-btn>
                </v-flex>
                <v-flex>
                  <v-btn
                    :disabled="nextButtonDisabled"
                    block
                    color="heron_success"
                    @click="next"
                  >
                    επομενο
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            :color="snackColor"
            :top="true"
          >
            {{ errorMessages }}
            <v-btn
              dark
              flat
              @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },
  data: () => ({
    termsCheckbox: false,
    nextButtonDisabled: true,
    termsCheckboxDisabled: true,
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    address: '',
    phone: '',
    afm: '',
    checkbox: false,
    errorMessages: '',
    snackbar: false,
    snackColor: '',
    color: 'general',
    checkboxError: false,
    zoom: 100,
    zoom_string: '100%',
    dataProcessingCheckbox: false,
    dataProcessingCheckboxDisabled: true
  }),

  created () {
    this.firstname =
      this.$route.params.data !== undefined
        ? this.$route.params.data.firstname
        : ''
    this.lastname =
      this.$route.params.data !== undefined
        ? this.$route.params.data.lastname
        : ''
    this.email =
      this.$route.params.data !== undefined
        ? this.$route.params.data.email
        : ''
    this.password =
      this.$route.params.data !== undefined
        ? this.$route.params.data.password
        : ''
    this.address =
      this.$route.params.data !== undefined
        ? this.$route.params.data.address
        : ''
    this.phone =
      this.$route.params.data !== undefined
        ? this.$route.params.data.phone
        : ''
    this.afm =
      this.$route.params.data !== undefined ? this.$route.params.data.afm : ''

    if (
      this.firstname == '' ||
      this.lastname == '' ||
      this.email == '' ||
      this.password == '' ||
      this.phone == '' ||
      this.afm == ''
    ) {
      this.$router.push('/register_user')
    }
  },
  methods: {
    download () {},
    zoomIn () {
      this.zoom += 10
      this.zoom_string = this.zoom.toString() + '%'
    },

    zoomOut () {
      this.zoom -= 10
      this.zoom_string = this.zoom.toString() + '%'
    },
    check: function () {
      this.nextButtonDisabled =
        !this.termsCheckbox || !this.dataProcessingCheckbox
    },
    handleScroll (e) {
      if (
        e.target.offsetHeight + e.target.scrollTop >=
        e.target.scrollHeight - 700
      ) {
        this.termsCheckboxDisabled = false
        this.dataProcessingCheckboxDisabled = false
      }
    },
    next () {
      if (this.termsCheckbox == false || this.dataProcessingCheckbox == false) {
        this.termsAndConditionsInline()
      } else {
        let firstname = this.firstname
        let lastname = this.lastname
        let email = this.email
        let password = this.password
        let address = this.address
        let phone = this.phone
        let afm = this.afm
        let termsCheckbox = this.termsCheckbox

        this.$router.push({
          name: 'extra_user_terms',
          params: {
            data: {
              firstname,
              lastname,
              email,
              password,
              address,
              phone,
              afm,
              termsCheckbox
            }
          }
        })
      }
    },
    back () {
      let firstname = this.firstname
      let lastname = this.lastname
      let email = this.email
      let password = this.password
      let address = this.address
      let phone = this.phone
      let afm = this.afm

      this.$router.push({
        name: 'register_user',
        params: {
          data: { firstname, lastname, email, password, address, phone, afm }
        }
      })
    },
    termsAndConditionsInline () {
      this.snackbar = true
      this.snackColor = 'error'
      this.errorMessages =
        'Οι όροι και προϋποθέσεις συμμετοχής όπως και η επεξεργασία των προσωπικών δεδομένων πρέπει να γίνουν αποδεκτοί'
    }
  },
  metaInfo () {
    return {
      title: 'HERON Energy Control'
    }
  }
}
</script>

<style scoped>
.background {
  background: url("../assets/img/heron_background_new.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.v-card {
  display: flex !important;
  flex-direction: column;
}
.v-card__text {
  flex-grow: 1;
  overflow: auto;
}
.highlight--text /deep/ label {
  color: #323d77;
  font-size: 15px;
}
.v-toolbar__title {
  font-size: 1.5rem !important;
}
</style>
